import {Component} from '@angular/core';
import {Input} from '@angular/core';

function clamp(value) {
    return Math.max(0, Math.min(value, 100));
}

@Component({
    selector: 'ui-progress-bar',
    template: `<div class="indicator" [style.width]="value + '%'"></div>`,
    styleUrls: ['progress-bar.component.scss']
})
export class UIProgressBarComponent {

    private _value: number;

    @Input()
    set value(value: number) {
        this._value = clamp(value);
    }

    get value() {
        return this._value;
    }
}